import React, { useContext, useEffect, useState } from 'react';
import ItemCard from '../../../../../../components/itemCard';
import GlobalContext from '../../../../../../context/globalContext';
import { useToast } from '../../../../../../context/toast';
import {
  useGetSettings,
  useUpdateSettingsData,
} from '../../../../../../services/settings';
import url from './url';
import Input from '../../../../../../components/input';
import Button from '../../../../../../components/button';
import { Modal } from '../../../../../../components/modal';

const Version = () => {
  const { data, refetch } = useGetSettings();
  const figurData = data?.data.figur;
  const [open, setOpen] = useState(false);
  const { mutate, isLoading } = useUpdateSettingsData();
  const [version, setVersion] = useState<string>('');
  const { deviceDetails, setDeviceDetails, cardType } =
    useContext(GlobalContext);
  const { addToast } = useToast();

  const submit = () => {
    mutate(
      {
        figur: {
          ...figurData,
          android:
            cardType === 'android'
              ? { ...figurData?.android, version: version }
              : figurData?.android,
          ios:
            cardType === 'ios'
              ? { ...figurData?.ios, version: version }
              : figurData?.ios,
        },
      },
      {
        onSuccess: () => {
          refetch();
          setOpen(false);
          addToast({ msg: 'Successfully Updated', type: 'success' });
          setDeviceDetails({ ...deviceDetails, version: version });
        },
      }
    );
  };

  useEffect(() => {
    if (deviceDetails) {
      setVersion(deviceDetails.version);
    }
  }, [deviceDetails, setVersion]);

  return (
    <div>
      <div onClick={() => setOpen(true)}>
        <ItemCard title="Version" hint={deviceDetails.version} />
      </div>

      <Modal
        padding={true}
        isVisible={open}
        center
        close={setOpen}
        title="Version"
        header={true}
        width="medium"
        showFooter
        footer={
          <div className="flex justify-end">
            <Button onClick={submit} loading={isLoading} disabled={isLoading}>
              Save Changes
            </Button>
          </div>
        }
      >
        <div className="flex flex-col gap-4 text-sm">
          <div>
            <div className="flex justify-between">
              <h5>Enter Version</h5>
            </div>
            <Input
              parentClassName="mt-2"
              defaultValue={version}
              onChange={(e) => setVersion(e.target.value)}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Version;
